// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M8.5 5V19H6.5V5H8.5ZM17.6642 6.75L12.4142 12L17.6642 17.25L16.25 18.6642L9.58579 12L16.25 5.33579L17.6642 6.75Z"}}]};

const PageFirstIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'page-first',
    ref,
    icon: element,
  },
));

PageFirstIcon.displayName = 'PageFirstIcon';

export default PageFirstIcon;
